import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from './../assets/images/logo.png';

export default class TROPICANA extends Component {
  render() {
    return (
      <div className="container my-4 notification-100">

        <header className="text-center">
          <img src={logo} alt="KREP" style={{ borderRadius: '8px' }} />
          <h1 className="mt-2">TROPICANA</h1>
        </header>

        {/* English Section */}
        <div className="section">
          <h3>English</h3>
          <ul>
            <li><span className="label">1. Gazette Notification number and Date:</span> S.O.3922 (E) Dated 12-09-2024</li>
            <li><span className="label">2. Title of Biostimulant:</span> (4) Sargassum tenerrimum 10% (Liquid)</li>
            <li><span className="label">3. Composition:</span>
              <ul>
                <li>(i) Alginic acid per cent. by weight, minimum: 2.0</li>
                <li>(ii) pH (1:2 aqueous solution): 8 - 10</li>
                <li>(iii) Organic matter (dry mass basis) per cent. by weight, minimum: 20.0</li>
              </ul>
            </li>
            <li><span className="label">4. Crop:</span> Paddy and Tomato</li>
            <li><span className="label">5. Doses:</span>
              <ul>
                <li>(i) Paddy: One foliar application at 625 ml/ha</li>
                <li>(ii) Tomato: Two foliar applications at 625 ml/ha</li>
              </ul>
            </li>
          </ul>
        </div>

        {/* Hindi Section */}
        <div className="section">
          <h3>हिन्दी</h3>
          <ul>
            <li><span className="label">1. राजपत्र अधिसूचना संख्या एवं दिनांक:</span> एस.ओ.3587 (ई) दिनांक 12-09-2024</li>
            <li><span className="label">2. जैवउत्तेजक का नाम:</span> (4) सार्गासम टेनेरिमुम 10% (द्रव)</li>
            <li><span className="label">3. संघटन:</span>
              <ul>
                <li>(i) एल्जिनिक अम्ल भार के अनुसार प्रतिशत, न्यूनतम: 2.0</li>
                <li>(ii) पीएच (1:2 जलीय घोल): 8 - 10</li>
                <li>(iii) कार्बनिक पदार्थ (शुष्क द्रव्यमान के आधार पर) भार के अनुसार प्रतिशत, न्यूनतम: 20.0</li>
              </ul>
            </li>
            <li><span className="label">4. फसल:</span> धान और टमाटर</li>
            <li><span className="label">5. मात्रा:</span>
              <ul>
                <li>(i) धान: 625 मिली/हेक्टेयर की दर से एक पर्णीय छिड़काव</li>
                <li>(ii) टमाटर: 625 मिली/हेक्टेयर की दर से दो पर्णीय छिड़काव</li>
              </ul>
            </li>
          </ul>
        </div>

        {/* Marathi Section */}
        <div className="section">
          <h3>मराठी</h3>
          <ul>
            <li><span className="label">१. राजपत्र अधिसूचना क्रमांक आणि तारीख:</span> एस.ओ.३५८७ (ई) दिनांक १२-०९-२०२४</li>
            <li><span className="label">२. बायोस्टिम्युलंटचे शीर्षक:</span> (४) सरगासम टेनेरिमम १०% (द्रव)</li>
            <li><span className="label">३. रचना:</span>
              <ul>
                <li>(१) अल्जिनिक आम्ल टक्के. वजनाने, किमान: २.०</li>
                <li>(२) पीएच (१:२ जलीय द्रावण): ८ - १०</li>
                <li>(३) सेंद्रिय पदार्थ (कोरडे वस्तुमान आधारावर) टक्के. वजनाने, किमान: २०.०</li>
              </ul>
            </li>
            <li><span className="label">४. पीक:</span> भात आणि टोमॅटो</li>
            <li><span className="label">५. मात्रा:</span>
              <ul>
                <li>(१) भात: ६२५ मिली/हेक्टर दराने एक पानांवरील वापर</li>
                <li>(२) टोमॅटो: ६२५ मिली/हेक्टर दराने दोन पानांवरील वापर</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    )
  }
}
